require('../../next-input/lib/style.js');
require('../../next-select/lib/style.js');
require('../../next-button/lib/style.js');
require('../../next-icon/lib/style.js');
require('./main.scss');